export default __webpack_public_path__ + "static/media/Screenshot (9).101d05c5.png";